<template>
  <div class="footer">
    <footer-scroll></footer-scroll>
    <!-- <span id="star-five" class="scroll"></span> -->
    <el-divider></el-divider>
    <span @click="NewsDrawer = true" class="link">News</span>
    <el-divider direction="vertical"></el-divider>
    <span @click="StatisDrawer = true" class="link">Statistics</span>
    <el-divider direction="vertical"></el-divider>
    <span @click="contactDrawer = true" class="link">Contact</span>
    <br/>
    <br/>
    <span class="copyright">
      <slot name="copyright">
        &copy; 2022–2023 Xinkai Zhou. All right reserved. This web application is maintained by the  
        &middot; <a href="https://compbio.nju.edu.cn" style="text-decoration: none;"> NJU Computational Biology Group </a> &middot;
      </slot>
    </span>
    <!-- News Drawer -->
    <el-drawer
      title="News"
      size="300px"
      :visible.sync="NewsDrawer"
      :direction="NewsDirection"
      style="text-align:left"
    >
      <el-timeline>
        <el-timeline-item timestamp="2023/7/10">
          <b>Database v1.1 released</b>
          <br/>
          Add the download of vector graphics
          <br/>
          Add the download of Blast Reference
          <br/>
          Add external links of CellType ID
          <br/>
          Add GSEA-KEGG function
        </el-timeline-item>
        <el-timeline-item timestamp="2023/5/24">
          <b>Data Update: </b>
          <br/>
          Add 4 more species
        </el-timeline-item>
        <el-timeline-item timestamp="2023/4/27">
          <b>Database v1.0 released</b>
        </el-timeline-item>
        <el-timeline-item timestamp="2023/4/13">
          <b>Data Update: </b>
          <br/>
          Add 3 more species
        </el-timeline-item>
        <el-timeline-item timestamp="2023/2/8">
          <b>Database Online</b>
        </el-timeline-item>
      </el-timeline>
    </el-drawer>
    <!-- Statistic Drawer -->
    <el-drawer
      title="Statistics"
      size="50%"
      :visible.sync="StatisDrawer"
      :direction="StatisDirection"

    >
      <iframe :width="statisWidth-50" :height="(statisWidth-50)*0.75" frameborder="0" style="border:0" allowfullscreen
      src="https://lookerstudio.google.com/embed/reporting/81c7bcc7-85f2-4103-bf1d-c4f6c79a1941/page/iArRD">
      </iframe>
    </el-drawer>
    <!-- Contact Drawer -->
    <el-drawer
      title="Contact us"
      size="35%"
      :visible.sync="contactDrawer"
      :direction="contactDirection"
    >
      <p class='info'>
        <i class="el-icon-message"></i>
        <slot name="email">
          E-mail: <a href="mailto:compbio@nju.edu.cn?subject=scDatabase">compbio@nju.edu.cn</a>
        </slot>
        <br/>
      </p>
      <p class="info">
        <i class="bi-mailbox"></i>
        <slot name="post">
          Post code: 210023
        </slot>
        <br/>
      </p>
      <p class="info">
        <i class="el-icon-location-outline"></i>
        <slot name="location">
          Room A529, Life science building, Nanjing University, No.163 Xianlin Road, Qixia District, Nanjing, Jiangsu, China
        </slot>
      </p>
      
      <div class="card-body">
        <slot name="map">
          <iframe width="100%" height="500" frameborder="0" src="https://cn.bing.com/maps/embed?h=480&amp;w=725&amp;cp=32.11716849135678~118.95921611785887&amp;lvl=16&amp;typ=d&amp;sty=r&amp;src=SHELL&amp;FORM=MBEDV8" ></iframe> 
          <div style="white-space: nowrap; text-align: center; padding: 6px 0;">
            <a id="largeMapLink" target="_blank" href="https://cn.bing.com/maps?cp=32.11716849135678~118.95921611785887&amp;sty=r&amp;lvl=16&amp;FORM=MBEDLD">View Larger Map</a> &nbsp; | &nbsp;
            <a id="dirMapLink" target="_blank" href="https://cn.bing.com/maps/directions?cp=32.11716849135678~118.95921611785887&amp;sty=r&amp;lvl=16&amp;rtp=~pos.32.11716849135678_118.95921611785887____&amp;FORM=MBEDLD">Get Directions</a>
          </div>
        </slot>
      </div>
    </el-drawer>
  </div>
  
</template>

<script>
import FooterScroll from './FooterScroll.vue'
export default {
  components: { FooterScroll },
  data() {
    return {
      contactDrawer: false,
      contactDirection: 'ltr',

      NewsDrawer: false,
      NewsDirection: 'rtl',

      StatisDrawer: false,
      StatisDirection: 'ltr',
    }
  },
  computed: {
    statisWidth() {
      return document.documentElement.clientWidth*0.5
    }
  }
}
</script>

<style>
  .footer{
    height: 120px;
    text-align: center;
    font-size: 16px;
    padding: 0px 100px;
    position: relative;
  }
  .footer .link {
    cursor: pointer;
    font-weight: 600;
  }
  .copyright{
    font-size: 12px;
  }
  .footer .info{
    font-size: 14px;
    color: #72767b;
    line-height: 25px;
  }
  .footer a{
    text-decoration: none;
  }
  .footer .card-body {
    width: 90%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: auto;
    padding: 10px;
  }
  .footer .card-body a {
    text-decoration: none;
  }
</style>